/**
 * @module ComplementaryMenu
 * @description
 */
import React, { FC } from "react";
import Link from "next/link";
import { stringify } from "ui/js/utils/filters";
import { Navigation, Menu, Dropdown } from "ui/components/Navigation";
import { handleClick } from "../helpers";
import styles from "../styles/ComplementaryMenu.module.css";
import state from "ui/js/config/state";

interface MenuItem {
  href: string;
  title: string;
  target?: string;
}

interface Props {
  className?: string;
  links: MenuItem[];
}

const ComplementaryMenu: FC<Props> = ({ ...props }) => {
  const { className = "", links } = props;

  const isNoLinksGiven = links.length === 0;
  const resiLink = links[0];
  const titleLink = links[1];
  const dropdownLinks = links.slice(2);

  return (
    <Navigation
      className={`${styles.navigation} ${className}`}
      ariaLabel="Sticky Navigation"
    >
      <Menu className={styles.menu} ariaLabel="Sticky Menu">
        {state.is_desktop && !isNoLinksGiven ? (
          <>
            <li
              className={`${styles.li} ${resiLink.href === "/" && styles.isActive}`}
              role="menuitem"
            >
              <Link
                href={resiLink.href}
                target={resiLink.target}
                onClick={handleClick}
                className={styles.a}
                data-payload={stringify({
                  position: "MASTHEAD",
                  text: resiLink.title,
                  actionOutcome: "INTERALLINK",
                })}
              >
                {resiLink.title}
              </Link>
            </li>
            <Dropdown
              ariaLabel="Sticky Dropdown"
              className={styles.dropdown}
              title={
                <li
                  className={`${styles.li} ${titleLink.href === "/" && styles.isActive}`}
                  role="menuitem"
                >
                  <Link
                    href={titleLink.href}
                    target={titleLink.target}
                    onClick={handleClick}
                    className={styles.a}
                    data-payload={stringify({
                      position: "MASTHEAD",
                      text: titleLink.title,
                      actionOutcome: "INTERALLINK",
                    })}
                  >
                    {titleLink.title}{" "}
                    <span className={`icon icon-chevron-down`} />
                  </Link>
                  {/* <button
                  className={ styles.a }
                  type="button"
                  onClick={ handleClick }
                  data-payload={ stringify( {
                    text: titleLink.title,
                    actionOutcome: 'INTERALLINK'
                  } ) }
                  role="button">{ titleLink.title }</button> */}
                </li>
              }
              menu={dropdownLinks.map((link: MenuItem, index: number) => (
                <li
                  key={index}
                  className={`${styles.li} ${link.href === "/" && styles.isActive}`}
                  role="menuitem"
                >
                  <Link
                    href={link.href}
                    target={link.target}
                    onClick={handleClick}
                    className={styles.a}
                    data-payload={stringify({
                      position: "MASTHEAD",
                      text: link.title,
                      actionOutcome: "INTERALLINK",
                    })}
                  >
                    {link.title}
                  </Link>
                </li>
              ))}
            />
          </>
        ) : (
          <>
            {links.map((link: MenuItem, index: number) => (
              <li
                key={index}
                className={`
                  ${styles.li}
                  ${link.href === "/" && styles.isActive}
                `}
                role="menuitem"
              >
                <Link
                  href={link.href}
                  target={link.target}
                  onClick={handleClick}
                  className={styles.a}
                  data-payload={stringify({
                    position: "MASTHEAD",
                    text: link.title,
                    actionOutcome: "INTERALLINK",
                  })}
                >
                  {link.title}
                </Link>
              </li>
            ))}
          </>
        )}
      </Menu>
    </Navigation>
  );
};

ComplementaryMenu.displayName = "ComplementaryMenu";

export default ComplementaryMenu;
